import * as React from 'react'

const Magazine = ({ ...props }) => {
  return (
    <svg width="1em" height="1em" viewBox="0 0 99 99" fill="none" {...props}>
      <circle cx="49.5" cy="49.5" r="49.5" fill="url(#paint0_linear)" />
      <path
        d="M49.784 31.2018C43.8915 23.4316 34.5639 26.5429 30.4719 28.1222L24.5766 31.2996C23.6055 31.823 23 32.8372 23 33.9404V65.0626C23 67.5231 25.799 68.9373 27.7798 67.4776L30.4719 65.4937C41.2951 58.9416 50.1346 67.3492 49.784 66.499M49.784 31.2018C54.8537 23.5582 66.045 26.0107 69.0109 28.1222L74.9988 31.3131C75.9664 31.8287 76.5756 32.8311 76.5878 33.9273L76.9356 65.2112C76.9627 67.6434 74.2361 69.095 72.2333 67.7147L69.0109 65.4937C58.7863 58.8137 49.3481 67.3492 49.784 66.499M49.784 31.2018V50.0349V66.499"
        stroke="white"
        strokeWidth="5"
      />
      <defs>
        <linearGradient
          id="paint0_linear"
          x1="32.0625"
          y1="-7.3125"
          x2="85.14"
          y2="84.15"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF8652" />
          <stop offset="1" stopColor="#A774FB" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export default Magazine
